import type { TableSort } from '@/ui';

/*
 * Сортировка списка в адресной строке: `field` или `field:desc`. Поля - белый
 * список бэкенда (SortFields поискового запроса): чужое поле из URL отбрасывается,
 * а не уходит в API за ответом 400.
 */

export const parseSort = (
  value: unknown,
  fields: ReadonlyArray<string>,
): TableSort | undefined => {
  if (typeof value !== 'string') return undefined;

  const [field = '', dir = 'asc'] = value.split(':');
  if (!fields.includes(field) || (dir !== 'asc' && dir !== 'desc'))
    return undefined;

  return { field, dir };
};

export const formatSort = (sort: TableSort): string =>
  `${sort.field}:${sort.dir}`;

export const isSameSort = (left: TableSort, right: TableSort): boolean =>
  left.field === right.field && left.dir === right.dir;
